import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';

import { checkDuplicateClaim } from '../data-provider/check-duplicate-claim';
import type { CheckDuplicateClaimRequestParams } from '../data-provider/check-duplicate-claim/api';

export interface UseCheckDuplicateClaimOptions {
  onSuccess?: (status: number) => void;
  onError?: (error: Error) => void;
  showLoader?: boolean;
}

export const useCheckDuplicateClaim = ({
  onSuccess,
  onError,
  showLoader = true,
}: UseCheckDuplicateClaimOptions = {}) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (params: CheckDuplicateClaimRequestParams) => checkDuplicateClaim(params),
    onError: (error: Error) => {
      if (showLoader) {
        dispatch(setAppLoader(false));
      }
      onError?.(error);
    },
    onMutate: () => {
      if (showLoader) {
        dispatch(setAppLoader(true));
      }
    },
    onSuccess: (status, _variables) => {
      if (showLoader) {
        dispatch(setAppLoader(false));
      }
      onSuccess?.(status);
    },
  });
};
